var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.expirationText)?_c('p',{class:[
      'branded-image-expiration',
      ( _obj = {}, _obj['branded-image-expiration__expires-soon'] = this.expiresSoon, _obj ),
      ( _obj$1 = {}, _obj$1['branded-image-expiration__expires-today'] = this.expiresToday, _obj$1 )]},[_vm._v("\n  "+_vm._s(_vm.expirationText)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }